'use strict';

/**
 * @ngdoc directive
 * @name courseApp.directive:tabset
 * @description
 * # tabset
 */
angular.module('courseApp')
    .directive('tabset', function () {
        return {
            restrict: 'E',
            transclude: true,
            scope: {},
            templateUrl: 'views/directives/tabset.html',
            bindToController: true,
            controllerAs: 'tabset',
            controller: function () {
                var self = this;
                self.tabs = [];
                self.addTab = function (tab) {
                    self.tabs.push(tab);
                    if (self.tabs.length === 1) {
                        tab.active = true;
                    }
                };
                self.select = function (selectedTab) {
                    angular.forEach(self.tabs, function (tab) {
                        if (tab.active && tab !== selectedTab) {
                            tab.active = false;
                        }
                    });
                    selectedTab.active = true;
                };
            }
        };
    });
